import { showModal } from 'modal.react.js';
import { useDispatch, useSelector } from 'react-redux';

import Share from 'components/Pages/Admin/Itineraries/Share';
import AgentContactsModalContent from 'components/shared/AgentContactsModalContent';
import area from 'components/shared/GlobalModalArea/area';
import Modal from 'components/shared/GlobalModalArea/Modal';
import { Phone, UserPlus, FilePdf } from 'components/shared/Icon/phosphorIcons';
import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { useLandingV2Context } from 'detailsv2/LandingV2/context';
import i18n from 'i18n';
import { logoutThunk } from 'store/auth/thunks';
import { currentAccountSelector } from 'store/user/selectors';
import { saveAsPDF } from 'utils/filesDownloaders/pdf';

import { IIcon } from '../../Admin/shared/ItinerariesItemLanding/LandingActions/types';
import { getNotifications } from '../LandingLayout/functions';
import { GP_AUTH_SIGNIN_ROUTE } from '../Routes/constants';
import { useGuestPortalRouteBuilder } from '../Routes/functions';
import s from './index.module.css';

export const useGuestPortalData = () => {
  const { data: proposal } = useLandingV2Context();
  const account = useSelector(currentAccountSelector);
  const { guestPortalHideCosts = false } = account.permissions;

  const dispatch = useDispatch();
  const { buildRoute } = useGuestPortalRouteBuilder();
  const notifications = getNotifications([proposal.brandSettings.accountId, proposal.id].join('_'), true);

  const onShareWithFriends = () => {
    showModal(area, (close) => (
      <Modal contentClassName={s.shareModal} isOpen toClose={close} withoutCloseBtn>
        <Share
          builder={false}
          itemId={proposal.type === 'guest_portal' ? proposal.id : proposal.guestPortalId!}
          landingShareUrl={proposal.landingShareUrl}
          itinerariesItemType={ITINERARIES_ITEM_TYPES.GUEST_PORTAL}
          closeModal={close}
          showPermissions={!guestPortalHideCosts}
          manageHideCosts={!guestPortalHideCosts}
          hideHideCosts={proposal.itineraryCostsPageHidden}
        />
      </Modal>
    ));
  };
  const onSaveAsPdf = () => {
    //@ts-ignore
    return saveAsPDF({ item: proposal, itinerariesItemType: proposal.type, translate: true });
  };

  const getContacts = () => {
    const consultantName =
      proposal.brandSettings.firstName && `${proposal.brandSettings?.firstName} ${proposal.brandSettings?.lastName}`;

    showModal(area, (res) => (
      <Modal
        className="custom-agent-contacts-modal"
        isOpen={true}
        toClose={res}
        contentClassName={s.contactsModal}
        size="lmd"
        noPadding
      >
        <AgentContactsModalContent
          phone={proposal.brandSettings?.contactPhone}
          whatsapp={proposal.brandSettings?.whatsapp!}
          mobile={proposal.brandSettings?.messagePhone!}
          email={proposal.brandSettings?.email}
          skype={proposal.brandSettings?.skype!}
          companyName={proposal.brandSettings?.companyName}
          consultantName={consultantName}
        />
      </Modal>
    ));
  };

  const actions = [
    {
      label: i18n.t('proposal_content.log_out'),
      onClick: () => dispatch(logoutThunk({ getSignInPath: () => GP_AUTH_SIGNIN_ROUTE })),
    },
  ];

  const iconsConfig: IIcon[] = [
    {
      type: 'share',
      icon: <UserPlus data-tip="" data-for="share" />,
      onClick: onShareWithFriends,
      hint: i18n.t('proposal_content.guest_portal.share.title'),
      isDisabled: false,
    },
    {
      type: 'pdf',
      icon: <FilePdf data-tip="" data-for="pdf" />,
      onClick: onSaveAsPdf,
      hint: i18n.t('proposal_content.file.download_as_pdf'),
      isDisabled: false,
    },
    {
      type: 'phone',
      icon: <Phone data-tip="" data-for="phone" />,
      onClick: getContacts,
      hint: i18n.t('proposal_content.contact.travel_consultant'),
      isDisabled: false,
    },
  ];

  return {
    iconsConfig,
    notifications,
    actions,
  };
};
